export type ListResourcesApiResponse = /** status 200  */ ResourceResponseBody[];
export type TransformedListResourcesApiResponse =
  /** status 200  */ TransformedResourceResponseBody[];
export type ListResourcesApiArg = void;
export type ListResourceScopeOptionsApiResponse = /** status 200  */ AclScopeOptionResponseBody[];
export type TransformedListResourceScopeOptionsApiResponse =
  /** status 200  */ TransformedAclScopeOptionResponseBody[];
export type ListResourceScopeOptionsApiArg = {
  resourceId: string;
  scopeId: string;
};
export type ListPermissionsApiArg = {
  roleId: string;
};
export type ListPermissionsApiResponse = /** status 200  */ PermissionResponseBody[];
export type ListUserPermissionsApiResponse = /** status 200  */ PermissionResponseBody[];

export type PermissionResponseBody = {
  id: string;
  roleId: string;
  resource: PermissionResourceResponseBody;
  type: PermissionType;
  action: PermissionActionResponseBody | null;
  field: PermissionFieldResponseBody | null;
  scope: PermissionScopeResponseBody | null;
};

export type GrantActionPermissionApiResponse = unknown;
export type GrantActionPermissionApiArg = GrantActionPermissionRequestBody;
export type GrantFieldPermissionApiResponse = unknown;

export type UpdateFieldPermissionApiArg = GrantFieldPermissionRequestBody;
export type UpdateFieldPermissionApiRes = unknown;
export type UpdateActionPermissionApiArg = GrantActionPermissionApiArg;
export type UpdateActionPermissionApiRes = unknown;
export type GrantFieldPermissionApiArg = GrantFieldPermissionRequestBody;
export type GrantResourcePermissionApiResponse = unknown;
export type GrantResourcePermissionApiArg = GrantResourcePermissionRequestBody;
export type RevokeResourcePermissionApiRes = unknown;
export type RevokeResourcePermissionApiArg = GrantResourcePermissionRequestBody;

export type RevokeAllPermissionApiRes = unknown;
export type RevokeAllPermissionApiArg = {roleId: string};
export type GrantAllPermissionApiRes = unknown;
export type GrantAllPermissionApiArg = {roleId: string};

export type RevokePermissionApiResponse = /** status 204  */ undefined;
export type RevokePermissionApiArg = {
  id: string;
  roleId: string;
};
export type ListUserPermissionsApiArg = void;
export type AclActionResponseBody = {
  id: string;
  name: string;
};
export type AclFieldResponseBody = {
  id: string;
  name: string;
};
export type TransformedAclActionResponseBody = {
  id: string;
  name: string;
};
export type AclScopeOptionResponseBody = {
  id: string;
  name: string;
};
export type TransformedAclScopeOptionResponseBody = {
  value: string;
  label: string;
};
export type AclScopeResponseBody = {
  id: string;
  name: string;
  options: AclScopeOptionResponseBody[];
};
export type TransformedAclScopeResponseBody = {
  value: string;
  label: string;
};
export type ResourceResponseBody = {
  id: string;
  name: string;
  actions: AclActionResponseBody[];
  fields: AclFieldResponseBody[];
  scopes: AclScopeResponseBody[];
  subResources: ResourceResponseBody[];
};
export type TransformedResourceResponseBody = {
  id: string;
  name: string;
  actions: TransformedAclActionResponseBody[];
  fields: TransformedAclActionResponseBody[];
  scopes: TransformedAclScopeResponseBody[];
  subResources: TransformedResourceResponseBody[];
};
export type PermissionResourceResponseBody = {
  id: string;
  name: string;
};
export type PermissionType = 'ACTION' | 'FIELD';
export type PermissionActionResponseBody = {
  id: string;
  name: string;
};

export type GrantActionPermissionRequestBody = {
  roleId: string;
  resourceId: string;
  actionId: string;
  scope: PermissionScopeRequestBody | null;
};
export type GrantFieldPermissionRequestBody = {
  roleId: string;
  resourceId: string;
  fieldId: string;
  scope: PermissionScopeRequestBody | null;
};
export type GrantResourcePermissionRequestBody = {
  roleId: string;
  resourceId: string;
};
export type ListUserAllowedResourceActionsApiResponse =
  /** status 200  */ AllowedActionResponseBody[];
export type AllowedActionResponseBody = {
  resourceId: string;
  actionId: string;
};
export type ListUserAllowedResourceActionsApiArg = unknown;
export type ListUserAllowedRecordActionsApiResponse =
  /** status 200  */ AllowedActionResponseBody[];
export type ListUserAllowedRecordActionsApiArg = {
  resourceId: string;
  recordId: string;
};

export type PermissionIdResponseBody = {
  id: string;
};
export type GrantPermissionApiResponse = /** status 201  */ PermissionIdResponseBody;
export type GrantPermissionApiArg = {
  grantPermissionRequestBody: GrantPermissionRequestBody;
};
export type GrantPermissionRequestBody = {
  roleId: string;
  resourceId: string;
  protectedUnitId: string;
  scopes: PermissionScopeRequestBody[];
};
export type UpdateProtectedUnitPermissionV2ApiResponse = unknown;
export type UpdateProtectedUnitPermissionV2ApiArg = {
  permissionId: string;
  updateActionPermissionRequestBody: UpdateActionPermissionRequestBody;
};
export type ListPermissionExpressionApiResponse =
  /** status 200  */ PermissionExpressionListResponseBody;
export type ListPermissionExpressionApiArg = void;
export type PermissionsExpressionScopeResponseBody = {
  scopeId: string;
  values: string[];
};
export type PermissionsExpressionConditionAlternativeResponseBody = {
  scopes: PermissionsExpressionScopeResponseBody[];
};
export type PermissionsExpressionConditionResponseBody = {
  alternatives: PermissionsExpressionConditionAlternativeResponseBody[];
};
export type PermissionsExpressionResponseBody = {
  result: 'ALLOW' | 'DISALLOW' | 'SCOPES_MUST_BE_EVALUATED';
  conditions: PermissionsExpressionConditionResponseBody[];
};
export type ResourceActionPermissionExpressionResponseBody = {
  resourceId: string;
  actionId: string;
  permissionsExpression: PermissionsExpressionResponseBody;
};
export type ResourceFieldPermissionExpressionResponseBody = {
  resourceId: string;
  fieldId: string;
  permissionsExpression: PermissionsExpressionResponseBody;
};
export type PermissionExpressionListResponseBody = {
  actions: ResourceActionPermissionExpressionResponseBody[];
  fields: ResourceFieldPermissionExpressionResponseBody[];
};
export type UpdateActionPermissionRequestBody = {
  scopes: PermissionScopeRequestBody[];
};
export type PermissionScopeRequestBody = {
  id: string;
  values: string[];
};
export type ListPermissionsV2ApiResponse = /** status 200  */ PermissionV2ResponseBody[];
export type ListUserPermissionsV2ApiResponse = /** status 200  */ UserPermissionV2ResponseBody[];
export type ListUserPermissionsV2ApiArg = void;
export type PermissionScopeValueResponseBody = {
  id: string;
  name: string;
};

export type PermissionFieldResponseBody = {
  id: string;
  name: string;
};
export type PutPermissionsApiArg = {
  roleId: string;
  permissions: {
    protectedUnitId: string;
    scopes: PermissionScopeRequestBody[];
  }[];
};
export type PutPermissionsApiResponse = unknown;
export type ListProtectedUnitsApiResponse = /** status 200  */ ProtectedGroupResponseBody[];
export type ListProtectedUnitsApiArg = void;
export type ProtectedUnitResponseBody = {
  id: string;
  name: string;
  scopes: ScopeResponseBody[];
};
export type ScopeResponseBody = {
  id: string;
  name: string;
  options: ScopeOptionResponseBody[];
};
export type ScopeOptionResponseBody = {
  id: string;
  name: string;
};
export type ProtectedGroupResponseBody = {
  id: string;
  name: string;
  protectedUnits: ProtectedUnitResponseBody[];
  children: ProtectedGroupResponseBody[];
};

export type UserPermissionV2ResponseBody = {
  resource: PermissionResourceResponseBody;
  type: PermissionType;
  action: PermissionActionResponseBody | null;
  field: PermissionFieldResponseBody | null;
  scopes: PermissionScopeResponseBody[];
};
export type PermissionScopeResponseBody = {
  id: string;
  name: string;
  values: PermissionScopeValueResponseBody[];
};
export type PermissionGroupResponseBody = {
  id: string;
  name: string;
};
export type PermissionProtectedUnitResponseBody = {
  id: string;
  name: string;
};

export type ListPermissionsV2ApiArg = {
  roleId: string;
};
export type PermissionV2ResponseBody = {
  id: string;
  roleId: string;
  group: PermissionGroupResponseBody;
  protectedUnit: PermissionProtectedUnitResponseBody;
  scopes: PermissionScopeResponseBody[];
};
